<template>
  <div class="header">
    <div class="box">
      <!-- logo -->
      <div class="logo" @click="tohome">
        <img src="../assets/images/logo.gif" alt="" />
      </div>
      <!-- 搜索框与菜单键 -->
      <div class="right">
        <div class="img" @click.stop="sou">
          <img
            v-show="findlink == false"
            src="../assets/imgapp/sousuo.png"
            alt=""
          />
          <input
            v-show="findlink"
            class="inpt_s"
            type="text"
            v-model="search"
            placeholder="请输入搜索内容"
            @change="tosearch()"
          />
        </div>
        <div class="cli" @click.stop="flg = !flg">
          <div v-if="flg == false" class="box_s">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="lg_x" v-else @click="sele = false">
            <img src="../assets/imgapp/x@2x.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 一级标题 -->
      <div v-show="sele == false" class="bot" :class="flg ? 'active' : ''">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click.stop="chancli(index)"
        >
          {{ item.name }}
          <img src="../assets/imgapp/head-x.png" alt="" />
        </div>
      </div>
      <!-- 二级标题 -->
      <div class="bot-right-b">
        <div class="bot-right" :class="sele == true ? 'bot-right-r' : ''">
          <div
            v-for="item in list[curindex].chard"
            :key="item.index"
            @click="link(item.index)"
            v-if="item.flagOff == true ?false : true"
          >
            {{ item.str }}
          </div>
          <div @click.stop="sele = false" class="f_btn">
            返回
            <img src="../assets/imgapp/head-l.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 黑色背景 -->
    <div class="box_bg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flg: false,
      sele: false,
      //搜索框显示影藏
      findlink: false,
      curindex: 0,
      list: [
        {
          id: -1,
          name: "恒生电子"
        },
        {
          id: 0,
          name: "新闻动态",
          chard: [
            {
              index: 1,
              str: "公司新闻",
            },
            {
              index: 2,
              str: "产品动态",
            },
            {
              index: 3,
              str: "市场活动",
              flagOff:true

            },
            {
              index: 4,
              str: "恒生世界",
            }
          ]
        },
        {
          id: 1,
          name: "产品与解决方案",
          chard: [
            {
              index: 5,
              str: "业务领域"
            },
            {
              index: 6,
              str: "行业解决方案"
            }
          ]
        },
        {
          id: 2,
          // name: "LIGHT",
          name: "技术平台"
        },
        {
          id: 3,
          name: "客户服务"
        },
        {
          id: 4,
          name: "投资者关系",

          chard: [
            {
              index: 7,
              str: "临时公告"
            },
            {
              index: 8,
              str: "定期公告"
            }
          ]
        },

        {
          id: 5,
          name: "可持续发展",
          chard: [
            {
              index: 16,
              str: "恒生ESG"
            },
            {
              index: 17,
              str: "恒生公益基金会"
            }
          ]
        },
        {
          id: 6,
          name: "关于恒生",
          chard: [
            {
              index: 9,
              str: "关于恒生"
            },
            // {
            //   index: 10,
            //   str: "管理团队",
            // },
            {
              index: 11,
              str: "发展历程"
            },
            {
              index: 12,
              str: "荣誉资质"
            },
            {
              index: 13,
              str: "联系我们"
            }
          ]
        },
        {
          id: 7,
          name: "加入我们",
          chard: [
            {
              index: 14,
              str: "社会招聘"
            },
            {
              index: 15,
              str: "校园招聘"
            }
          ]
        }
      ],
      search: ""
    };
  },
  methods: {
    chancli(index) {
      if (
        index == 0 ||
        index == 1 ||
        index == 2 ||
        index == 5 ||
        index == 6 ||
        index == 7 ||
        index == 8
      ) {
        this.sele = true;
        this.curindex = index;
      }
      //一级页面跳转
      switch (index) {
        case 0:
          console.log(index);
          this.$router.push({ path: "/" });
          this.getflg();
          break;
        // case 2:
        //   this.$router.push({ path: "/light" });
        //   this.getflg();
        //   break;
        case 3:
          this.$router.push({ path: "/light" });
          this.getflg();
          break;
        case 4:
          this.$router.push({ path: "/customer" });
          this.getflg();
          break;
        // case 5:
        //   window.open("https://gongyi.hundsun.com/gy/", "_blank");
        //   this.getflg();
        //   break;
      }
    },

    //表单输入事件
    tosearch() {
      if (this.$route.query.search == this.search) return;
      this.$router.push({ path: "/findpage", query: { search: this.search } });
      this.search = "";
    },
    getflg() {
      this.flg = !this.flg;
      this.sele = false;
    },

    //二级页面跳转
    link(index) {
      switch (index) {
        case 1:
          this.$router.push({ path: "/news/company" });
          this.getflg();
          break;
        case 2:
          this.$router.push({ path: "/news/product" });
          this.getflg();
          break;
        case 3:
          this.$router.push({ path: "/news/bazaar" });
          this.getflg();
          break;

        case 4:
          this.$router.push({ path: "/news/world" });
          this.getflg();
          break;
        case 5:
          this.$router.push({ path: "/business" });
          this.getflg();
          break;
        case 6:
          this.$router.push({ path: "/industry" });
          this.getflg();
          break;
        case 7:
          this.$router.push({ path: "/investor" });
          this.getflg();
          break;
        case 8:
          this.$router.push({ path: "/investort" });
          this.getflg();
          break;
        case 9:
          this.$router.push({ path: "/about" });
          this.getflg();
          break;
        // case 10:
        //   this.$router.push({ path: "/abouttwo" });
        //   this.getflg();
        //   break;
        case 11:
          this.$router.push({ path: "/aboutthree" });
          this.getflg();
          break;
        case 12:
          this.$router.push({ path: "/aboutfour" });
          this.getflg();
          break;
        case 13:
          this.$router.push({ path: "/aboutfive" });
          this.getflg();
          break;
        case 14:
          window.open("http://hundsun.51job.com/sz.html", "_blank");
          this.getflg();
          break;
        case 15:
          window.open("http://campus.hundsun.com/", "_blank");
          this.getflg();
          break;

        case 16:
          this.$router.push({ path: "/esg" });
          this.getflg();
          break;

        case 17:
          // window.open("https://gongyi.hundsun.com/gy/", "_blank");
          window.open(
            "https://gongyi.hundsun.com/gy/jjh/index_jjh.html",
            "_blank"
          );
          this.getflg();
          break;
      }
    },
    //
    chone() {
      this.findlink = false;
      this.flg = false;
    },
    //logo跳转首页
    tohome() {
      if (this.$until.dev("/", this.$route.path)) return;
      this.$router.push({ path: "/" });
    },
    //
    sou() {
      this.findlink = true;
      this.flg = false;
      this.sele = false;
    }
  },
  mounted() {
    document.body.addEventListener("click", this.chone);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.chone);
  }
};
</script>

<style scoped>
.header {
  background: linear-gradient(
    313deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-bottom: 1px solid rgba(2, 18, 67, 0.1);
}
/* .box_bg{
  margin-top: 90px;
  position:fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.65);
  width: 100vw;
  height: 100vh;
  z-index: 49;
} */

.inpt_s::-webkit-input-placeholder {
  color: #d9dde2;
}
.box {
  width: 750px;
  height: 88px;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center;
  position: relative;
}
.right {
  display: flex;
  align-items: center;
}
.right .img img {
  width: 41px;
  height: 41px;
  margin-right: 44px;
}
.right .img .inpt_s {
  font-size: 28px;
  font-weight: 400;
  line-height: 40px;
  background: #ffffff;
  padding: 14px 0 14px 43px;
  box-shadow: 2px 2px 6px 0px rgba(189, 193, 204, 0.53);
  margin-right: 30px;
  position: relative;
}
.right .img .inpt_s::after {
  content: " ";
  position: absolute;
  right: 21px;
  top: 14px;
  display: block;
  border: 1px solid #f00;
  width: 40px;
  height: 40px;
  background: url(../assets/imgapp/sousuo.png);
}
.cli .box_s {
  width: 44px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cli .lg_x img {
  width: 44px;
  height: 44px;
}
.cli .box_s span {
  width: 41px;
  height: 4px;
  background: #333;
}

.box .bot {
  width: 619px;
  height: 0;
  overflow: hidden;
  background: #f7fafe;
  position: absolute;
  top: 88px;
  right: 0;
  z-index: 50;
  transition: height 0.3s linear;
}
.box .active {
  height: 952px;
}
.box .bot > div {
  height: 119px;
  box-shadow: 0px -1px 0px 0px rgba(217, 217, 217, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 36px;
  font-size: 28px;
  color: #333333;
}
.box .bot > div > img {
  width: 16px;
  height: 9px;
}
.box .bot > div:nth-child(1) img,
.box .bot > div:nth-child(4) img,
.box .bot > div:nth-child(5) img {
  display: none;
}
.bot-right-b {
  overflow: hidden;
  position: absolute;
  top: 88px;
  right: 0;
  z-index: 55;
  transition: width 0.3s ease;
  width: 619px;
}
.bot-right {
  z-index: 10;
  background: linear-gradient(270deg, #1e88f0 0%, #4a47ff 100%);
  transform: translateX(619px);
  height: 0;
}
.box .bot-right-r {
  height: auto;
  transform: translateX(0px);
  z-index: 15;
  transition: all 0.3s linear;
}
.bot-right > div {
  height: 120px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  font-size: 28px;
  padding-left: 36px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 40px;
}

.bot-right .f_btn img {
  width: 9px;
  height: 16px;
  margin-left: 12px;
  margin-top: 4px;
}
@media (max-width: 750px) {
  .logo img {
    width: 90px;
    height: 55px;
  }
}
</style>
